import { useCallback, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faLock, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useLoginStore } from '../../../store/useLogin';

const LoginForm = ({
  isRegistration,
  setIsRegistration,
}: {
  isRegistration: boolean;
  setIsRegistration: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { isAuthenticated, login } = useLoginStore();

  const [id, setId] = useState<string>('');
  const [pw, setPw] = useState<string>('');
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const onChangeId = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setId(e.target.value);
  }, []);

  const onChangePw = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setPw(e.target.value);
  }, []);

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    login(id, pw);
  };

  const onClickRegister = (e: React.FormEvent) => {
    e.preventDefault();
    setIsRegistration(true);
  };
  
  return (
    <form
      onSubmit={handleLogin}
      className="!space-y-6"
    >
      <div className="!text-center !mb-8">
        <h2 className="!text-2xl !font-bold !text-gray-800">로그인</h2>
        <p className="!text-sm !text-gray-500 !mt-2">Fortune LAB 서비스에 오신 것을 환영합니다</p>
      </div>
      
      {/* 아이디 입력 */}
      <div>
        <label className="!block !text-sm !font-medium !text-gray-700 !mb-2">
          아이디
        </label>
        <div className="!relative">
          <div className="!absolute !inset-y-0 !left-0 !pl-3 !flex !items-center !pointer-events-none">
            <FontAwesomeIcon icon={faUser} className="!text-gray-400" />
          </div>
          <input
            type="text"
            value={id}
            onChange={onChangeId}
            placeholder="아이디를 입력해주세요"
            className="!w-full !pl-10 !pr-3 !py-3 !border !border-gray-200 !rounded-xl !bg-gray-50 !focus:bg-white !focus:outline-none !focus:ring-2 !focus:ring-indigo-500 !focus:border-transparent !transition-all !text-gray-900"
            style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif' }}
            required
          />
        </div>
      </div>
      
      {/* 비밀번호 입력 */}
      <div>
        <label className="!block !text-sm !font-medium !text-gray-700 !mb-2">
          비밀번호
        </label>
        <div className="!relative">
          <div className="!absolute !inset-y-0 !left-0 !pl-3 !flex !items-center !pointer-events-none">
            <FontAwesomeIcon icon={faLock} className="!text-gray-400" />
          </div>
          <input
            type={showPassword ? "text" : "password"}
            value={pw}
            onChange={onChangePw}
            placeholder="비밀번호를 입력해주세요"
            className="!w-full !pl-10 !pr-12 !py-3 !border !border-gray-200 !rounded-xl !bg-gray-50 !focus:bg-white !focus:outline-none !focus:ring-2 !focus:ring-indigo-500 !focus:border-transparent !transition-all !text-gray-900"
            style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif' }}
            required
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="!absolute !inset-y-0 !right-0 !pr-3 !flex !items-center !text-gray-400 hover:!text-gray-600"
          >
            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
          </button>
        </div>
      </div>
      
      {/* 버튼 영역 */}
      <div className="!space-y-3 !pt-4">
        <button
          type="submit"
          className="!w-full !py-4 !px-4 !bg-gradient-to-r !from-indigo-600 !to-purple-600 !text-white !font-semibold !rounded-xl !shadow-lg hover:!shadow-xl hover:!from-indigo-700 hover:!to-purple-700 !transform hover:!-translate-y-0.5 !transition-all !duration-200"
        >
          로그인
        </button>
        <button
          type="button"
          onClick={onClickRegister}
          className="!w-full !py-4 !px-4 !bg-gray-50 !text-gray-700 !font-medium !rounded-xl !border !border-gray-200 hover:!bg-gray-100 hover:!border-gray-300 !transition-all !duration-200"
        >
          회원가입
        </button>
      </div>
    </form>
  );
};

export default LoginForm;
